<template>
  <div id="connect">
  	<div class="panel9">
      <div flex="cross:center main:center" class="mengban3">
        <!-- <div flex-box="1" class="youmeng"></div> -->
        <!-- <div flex-box="1" class="wumeng"></div> -->
      </div>
      <div class="bg">
        <div class="centerPart">
          <img class="textPic" src="../static/images/com_index_10bg.png"/>
          <!-- <img class="textPic2" src="../static/images/text_TOUCH.png"/> -->
          <img class="square" src="../static/images/square7.png"/>
          <img class="logo" src="../static/images/logo2.png"/>
        </div>
        <div flex="dir:left" class="center">
          <div><h3>联系我们</h3></div>
          <div flex="dir:top main:right">
            <h4>E-MAIL</h4>
            <p>david@iuxlabs.com</p>
            <h4>Phone</h4>
            <p>189-1831-8160</p>
            <!-- <p>021-68868866</p> -->
          </div>
          <div>
            <form flex="dir:top">
              <span class="item">
                <input v-model="name" v-bind:class="{bingo:formkeys['name'] && !name}" maxlength="32" debounce="200" id="name" type="text" value=""  placeholder="姓名" @focus="addClass('name')" @blur="removeClass('name')"/>
                <span class="error" v-bind:class="{bingo:formkeys['name'] && !name}">姓名不能为空</span>
              </span>
              <span class="item">
                <input v-model="email" debounce="200" v-bind:class="{bingo:(formkeys['email'] && !email) || (formkeys['email'] && email && !formvalues[1])}" maxlength="64" debounce="500" id="email" type="text" value="" placeholder="david@iuxlabs.com" @focus="addClass('email')" @blur="removeClass('email')"/>
                <span class="error" v-bind:class="{bingo:formkeys['email'] && !email}">邮箱不能为空</span>
                <span class="error" v-bind:class="{bingo:formkeys['email'] && email && !formvalues[1]}">邮箱错误</span>
              </span>
              <span class="item">
                <input v-model="phone" debounce="200" v-bind:class="{bingo:(formkeys['phone'] && !phone) || (formkeys['phone'] && phone && !formvalues[2])}" maxlength="11" id="phone" type="text" value="" placeholder="189-1831-8160" @focus="addClass('phone')" @blur="removeClass('phone')"  />
                <span class="error" v-bind:class="{bingo:formkeys['phone'] && !phone}">手机不能为空</span>
                <span class="error" v-bind:class="{bingo:formkeys['phone'] && phone && !formvalues[2]}">手机错误</span>
              </span>
              <input v-model="company" maxlength="64" id="company" type="text" value="" placeholder="公司名称" @focus="addClass('company')" @blur="removeClass('company')" />
              <textarea v-model="record" maxlength="128" name="" id="record" cols="30" rows="10" @focus="testClass('record')" @blur="reTestClass('record')">留言</textarea>
            </form>
          </div>
          <div flex-box="1" flex="main:right cross:bottom" @click="submit()">
          <span v-bind:class="{able:formvalues[0] && formvalues[1] && formvalues[2]}">发送</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      formkeys:{'name':false,'email':false,'phone':false},
      formvalues:[false,false,false],
      formsubmit:false,
      name:'',
      email:'',
      phone:'',
      company:'',
      record:'留言',
    }
  },
  watch:{
    'name': function(val) {
      if(val != "") {
        this.formvalues[0] = true;
        console.log(this.formvalues);
      } else {
        this.formvalues[0] = false;
        console.log(this.formvalues);
      }
    },
    'email': function(val) {
      if(val != "" && this.checkEmail(val)) {
        this.formvalues.$set(1,true);
        console.log(this.formvalues);

      } else {
        this.formvalues.$set(1,false);
        console.log(this.formvalues);
      }
    },
    'phone': function(val) {
      if(val != "" && this.checkPhone(val)) {
        this.formvalues.$set(2,true);
        console.log(this.formvalues);

      } else {
        this.formvalues.$set(2,false);
        console.log(this.formvalues);
      }
    }
  },
  methods:{
    addClass(tag) {
      $("#"+tag).addClass("active");
      this.formkeys[tag] = false;
    },
    removeClass(tag) {
      $("#"+tag).removeClass("active");
      this.formkeys[tag] = true;
    },
    testClass(tag) {
      var obj = $("#"+tag);
      if(obj.html() == "留言") {
        obj.html("");
      }
      obj.addClass("active");
    },
    reTestClass(tag) {
      var obj = $("#"+tag);
      if(obj.html() == "") {
        obj.html("留言");
      }
      obj.removeClass("active");
    },
    checkPhone(){
      var myreg = /^1\d{10}$/;
      if(!myreg.test(this.phone))
      {
          return false;
      }
      return true;
    },
    checkEmail() {
      var myreg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if(!myreg.test(this.email))
      {
          return false;
      }
      return true;
    },
    submitTry() {
      if(this.formvalues[0] && this.formvalues[1] && this.formvalues[2]) {
        this.formsubmit = true;
      } else {
        this.formsubmit = false;
      }
    },
    submit() {
      if(!this.formvalues[0] || !this.formvalues[1] || !this.formvalues[2]) {
        this.formkeys.name = true;
        this.formkeys.email = true;
        this.formkeys.phone = true;
        return;
      }

      this.$http.post('http://iuxlabs.com/iuxcontact/post.php', {
        name:'123',
        tel:'135',
        email:'12',
        message:'this.company',
        company:''
      }).then((response) => {
        console.log( response.json());
        console.log( response);
        var data =  response.json();
        if(data.error == "0") {
          console.log("成功");
        }
          // set data on vm
          //this.$set('someData', response.json())

      }, (response) => {
          // error callback
      });
    }
  }
}
</script>
<style lang="sass" scoped>
  * {
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap;
  }

  $blockHeight:662.5px;
  $blockWidth:1060px;

  .mengban3 {
    position: absolute;
    left:0;
    right:0;
    top:0;
    bottom:0;
    background-color: rgba(0,0,0,0.68);
    z-index:1;
    .youmeng {
      width:380px;
      height:100%;
      background-color: rgba(37,39,50,0.68);
    }
    .wumeng {
      width:680px;
      height:100%;
    }
  }

  .panel9 {
    position: relative;
    height: 606px;
    background: url(../static/images/com_index_10bg.jpg) no-repeat center center;
    background-size: cover;
    /*background-color: rgba(0,0,0,0.32);*/
    /*background: rgba(0,0,0,0.32);*/
    .bg {
      position: relative;
      width:1060px;
      height:100%;
      margin:0 auto;
      overflow: visible;
      .centerPart {
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom:0;
        z-index: 2;
        .textPic {
          position: absolute;
          top: 255.3px;
          width: 313.6px;
          left: -43px;
        }
        .textPic2 {
          position: absolute;
          width: 337.87px;
          bottom: 243.8px;
          left: -43px;
        }
        .square {
          position: absolute;
          width: 171.37px;
          top: 115px;
          left: 48px;
        }
        .logo {
          position: absolute;
          width: 121px;
          top: 65.37px;
          right: 0px;
        }
      }
      .center {
        position: absolute;
        top:0;
        right:0;
        left:0;
        bottom:0;
        z-index: 3;
        color:white;
        overflow: visible;

        div:nth-child(1) {
          width:173px;
          padding-top: 142px;
          position: relative;
          left: -38px;
          /*margin-left: -50px;*/
        }
        div:nth-child(2) {
          width:207px;
          vertical-align: bottom;
          padding-bottom: 80px;
          text-align: left;
          h4 {
            font-size: 19px;
            line-height: 20px;
            margin-top: 20px;
          }
          p {
            font-size: 15px;
            line-height: 20px;
            color:rgb(58,151,247);
          }
        }
        div:nth-child(3) {
          form {
            margin-top: 90px;
            margin-left:76px;
            width:388.66px;

            .item {
              position: relative;
              .error {
                position: absolute;
                right:0;
                top:26px;
                z-index: -1;
                color:#b90000;
                display: none;
                &.bingo {
                  display: inline-block;
                }
              }
            }

            input[type=text] {
              width:100%;
              background: none;
              border:none;
              font-size: 19px;
              height:61px;
              border-bottom: 1px solid #f7f8f2;
              outline:none;
              -webkit-tap-highlight-color:none;
              color:white;
              &::-webkit-input-placeholder {
                color: rgba(255,255,255,.6);
              }
              &.bingo {
                border-color:#b90000;
              }
            }
            input.active {
              color:#3af7b2;
              border-color:#3af7b2;
              &::-webkit-input-placeholder {
                color:rgba(255,255,255,.4);
              }
            }
            textarea {
              width:100%;
              background: none;
              border:none;
              font-size: 19px;
              color:#a4a4a4;
              border-bottom: 1px solid #f7f8f2;
              padding-top: 22px;
              height:120px;
              resize:none;
              outline:none;
              -webkit-tap-highlight-color:none;
              color:white;
              &.record {
                color:white;
              }
              &.active {
                color:#3af7b2;
                border-color:#3af7b2;
              }
            }
          }
        }
        div:nth-child(4) {
          span {
            font-size: 15px;
            line-height: 20px;
            border: 2px solid #8f8f8f;
            color: #8f8f8f;
            padding: 7px 35px;
            margin:0 17px 64px 0;
            &.able {
              color:#3af7b2;
              border-color:#3af7b2;
              cursor: pointer;
            }
          }
        }
        h3 {
          font-size: 25px;
        }
      }
    }
  }
  @media screen and (max-width:1060px) and (min-width: 800px){
    $blockHeight:480px;
    $blockWidth:768px;
    $percent:0.72;
    .mengban3 {
      position: absolute;
      left:0;
      right:0;
      top:0;
      bottom:0;
      background-color: rgba(0,0,0,0.68);
      z-index:1;
      .youmeng {
        width:380*$percent+px;
        height:100%;
        background-color: rgba(37,39,50,0.68);
      }
      .wumeng {
        width:680*$percent+px;
        height:100%;
      }
    }

    .panel9 {
      position: relative;
      height: $blockHeight;
      /*background: url(../static/images/bg_6.jpg) no-repeat center center;*/
      /*background-size: cover;*/
      .bg {
        position: relative;
        width:$blockWidth;
        height:100%;
        margin:0 auto;
        overflow: visible;
        .centerPart {
          position: absolute;
          top:0;
          right:0;
          left:0;
          bottom:0;
          z-index: 2;
          .textPic {
            position: absolute;
            top: 255.3*$percent+px;
            width: 313.6*$percent+px;
            left: -43px;
          }
          .textPic2 {
            position: absolute;
            width: 337.87*$percent+px;
            bottom: 243.8*$percent+px;
            left: -43px;
          }
          .square {
            position: absolute;
            width: 171.37*$percent+px;
            top: 115*$percent+px;
            left: 48*$percent+px;
          }
          .logo {
            position: absolute;
            width: 121*$percent+px;
            top: 65.37*$percent+px;
            right: 0px;
          }
        }
        .center {
          position: absolute;
          top:0;
          right:0;
          left:0;
          bottom:0;
          z-index: 3;
          color:white;
          div:nth-child(1) {
            width:173*$percent+px;
            padding-top: 142*$percent+px;
          }
          div:nth-child(2) {
            width:207*$percent+px;
            vertical-align: bottom;
            padding-bottom: 80*$percent+px;
            h4 {
              font-size: 19*$percent+px;
              line-height: 20*$percent+px;
              margin-top: 20*$percent+px;
            }
            p {
              font-size: 15*$percent+px;
              line-height: 20*$percent+px;
              color:rgb(58,151,247);
            }
          }
          div:nth-child(3) {
            form {
              margin-top: 110*$percent+px;
              margin-left:76*$percent+px;
              width:388.66*$percent+px;

              input[type=text] {
                background: none;
                border:none;
                font-size: 19*$percent+px;
                height:61*$percent+px;
                border-bottom: 1px solid #f7f8f2;
                outline:none;
                -webkit-tap-highlight-color:none;
                color:white;
                &::-webkit-input-placeholder {
                  color: rgba(255,255,255,.6);
                }
              }
              input.active {
                color:#3af7b2;
                border-color:#3af7b2;
                &::-webkit-input-placeholder {
                  color:rgba(255,255,255,.4);
                }
              }
              textarea {
                width:100%;
                background: none;
                border:none;
                font-size: 19*$percent+px;
                color:#a4a4a4;
                border-bottom: 1px solid #f7f8f2;
                padding-top: 22*$percent+px;
                height:120*$percent+px;
                resize:none;
                outline:none;
                -webkit-tap-highlight-color:none;
                color:white;
                &.record {
                  color:white;
                }
                &.active {
                  color:#3af7b2;
                  border-color:#3af7b2;
                }
              }
            }
          }
          div:nth-child(4) {
            span {
              font-size: 19*$percent+px;
              line-height: 20*$percent+px;
              border: 2px solid #8f8f8f;
              color: #8f8f8f;
              padding: 10*$percent+px 50*$percent+px;
              margin:0 2px 92*$percent+px 0;
            }
          }
          h3 {
            font-size: 25*$percent+px;
          }
        }
      }
    }
  }
  @media screen and (max-width:799px) {
    .panel9 {
      position: relative;
      height: auto;
      background: #3a97f7;
      .mengban3 {
        display: none;
      }
      .bg {
        background-color: #3a97f7;
        position: relative;
        width:auto;
        height:100%;
        margin:0 auto;
        overflow: visible;
        .centerPart {
          display: none;
        }
        .center {
          position: relative;
          z-index: 3;
          color:white;
          div {
            width:100%;
          }
          div:nth-child(1) {
            background: url("../static/images/phone/GET_IN_TOUCH.png") no-repeat center 120px;
            background-size:210px 22px; 
            width: 100%;
            padding: 60px 0 60px;
            text-align: center;
            left: 0;
            h3 {
              font-size: 16px;
              line-height: 42px;
              width:132px;
              height:42px;
              border:5px solid rgba(211,211,211,0.18);
              margin:0 auto;
            }
          }
          div:nth-child(2) {
            display: none;
          }
          div:nth-child(3) {
            form {
              margin:0;
              width:auto;
              padding:0 20px;

              .item {
                .error {
                  top:21px;
                  color:#e7ff20;
                }
              }
              input[type=text] {
                &::-webkit-input-placeholder {
                  color: rgba(255,255,255,.6);
                }
                font-size: 15px;
                line-height: 55px;
                height:55px;
                border-bottom: 1px solid rgba(255,255,255,.6);
                &.bingo {
                  border-color: #e7ff20;
                }
              }
              input.active {
                color:#3af7b2;
                border-color:#3af7b2;
                &::-webkit-input-placeholder {
                  color:rgba(255,255,255,.4);
                }
              }
              textarea {
                background: none;
                border:none;
                font-size: 15px;
                color:rgba(255,255,255,.6);
                border-bottom: 1px solid rgba(255,255,255,.6);
                padding-top: 20px;
                height:100px;
                &.active {
                  color:#3af7b2;
                  border-color:#3af7b2;
                }
              }
            }
          }
          div:nth-child(4) {
            padding:50px 20px 60px;
            span {
              width:100%;
              height:40px;
              font-size: 19px;
              line-height: 38px;
              border: 2px solid rgba(255,255,255,.6);
              color: rgba(255,255,255,.6);
              padding: 0;
              text-align: center;
              margin:0;
            }
          }
          h3 {
            font-size: 25px;
          }
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Connect.vue?346b79f4